import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCompanies({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchCompaniesSuccess(data));
    if (payload?.onSuccess) payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchCompaniesFailure(err?.response?.data));
    if (payload?.onFailure) payload.onFailure();
  }
}

export function* handleFetchCatalog({ payload }) {
  try {
    const res = yield call(API.fetchCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.fetchCatalogSuccess(data));
  } catch (err) {
    yield put(actions.fetchCatalogFailure(err?.response?.data));
  }
}

export function* handleCreatePackage({ payload }) {
  try {
    const res = yield call(API.createPackage, payload);
    const { data } = res;
    yield put(actions.createPackageSuccess(data));
    if (payload.onSuccess) payload.onSuccess();
  } catch (err) {
    yield put(actions.createPackageFailure(err?.response?.data));
    if (payload.onFailure) payload.onFailure();
  }
}

export function* handleFetchCommodities({ payload }) {
  try {
    const res = yield call(API.fetchCommoditiesForCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
    if (payload?.onSuccess) payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
    if (payload?.onFailure) payload.onFailure();
  }
}

export function* handleFetchTests({ payload }) {
  try {
    const res = yield call(API.fetchTestsForCommodityCatalog, payload);
    const { data } = res;
    yield put(actions.fetchTestsSuccess(data));
    if (payload?.onSuccess) payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchTestsFailure(err?.response?.data));
    if (payload?.onFailure) payload.onFailure();
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* packageAddSaga() {
  yield takeLatest(actions.fetchCompanies.type, handleFetchCompanies);
  yield takeLatest(actions.fetchCatalog.type, handleFetchCatalog);
  yield takeLatest(actions.createPackage.type, handleCreatePackage);
  yield takeLatest(actions.fetchCommodities.type, handleFetchCommodities);
  yield takeLatest(actions.fetchTests.type, handleFetchTests);
}
